module.exports = __webpack_public_path__ + "img/hr-train-stop-shadow.db128d17.png";